import { ABaseModel } from '../abstracts/ABaseModel.js';
import {
  ICollectionLocale,
  ICollection,
  ICollectionPaginationResult,
  ICollectionListResult,
  ICollectionMeta,
  ICollectionArt,
  ICollectionArtLocale,
  ICollectionArtListResult,
  ICollectionArtPaginationResult,
} from '../interfaces/Collection.js';
import { Art } from './Art.js';
import { ImageHierarchical } from './Image.js';
import { Author } from './User.js';
import { PaginationResult, ListResult } from './List.js';

/**
 * CollectionLocale
 */
class CollectionLocale extends ABaseModel implements ICollectionLocale {
  id: number;
  localeCode: string;
  slug: string;
  name: string;
  description: string;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * Collection
 */
class Collection extends ABaseModel implements ICollection {
  id: number;
  status: number;
  hide: boolean;
  slug: string;
  name: string;
  description: string;
  summary: string;
  author: Author;
  images: Array<ImageHierarchical>;
  locales: Array<CollectionLocale>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * CollectionPaginationResult
 */
class CollectionPaginationResult extends PaginationResult implements ICollectionPaginationResult {
  declare items: Array<Collection>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * CollectionListResult
 */
class CollectionListResult extends ListResult implements ICollectionListResult {
  declare items: Array<Collection>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * CollectionMeta
 */
class CollectionMeta extends ABaseModel implements ICollectionMeta {
  id: number;
  collectionId: number;
  type: string;
  value: string;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * CollectionArtLocale
 */
class CollectionArtLocale extends ABaseModel implements ICollectionArtLocale {
  id: number;
  localeCode: string;
  description: string;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

class CollectionArt extends ABaseModel implements ICollectionArt {
  collectionId: number;
  artId: number;
  description: string;
  sort: number;
  status: number;
  art: Art;
  locales: Array<CollectionArtLocale>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * CollectionArtPaginationResult
 */
class CollectionArtPaginationResult extends PaginationResult implements ICollectionArtPaginationResult {
  declare items: Array<CollectionArt>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * CollectionArtListResult
 */
class CollectionArtListResult extends ListResult implements ICollectionArtListResult {
  declare items: Array<CollectionArt>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export {
  CollectionLocale,
  Collection,
  CollectionPaginationResult,
  CollectionListResult,
  CollectionMeta,
  CollectionArt,
  CollectionArtLocale,
  CollectionArtListResult,
  CollectionArtPaginationResult,
};
